<template>
  <div class="field-wrap">
    <label :for="name" class="label" v-html="label" />
    <vue-tel-input
      :id="name"
      :class="{ 'input-el--invalid': isInvalid, disabled }"
      :preferred-countries="['pl', 'gb', 'de', 'us', 'ru', 'ua', 'cz']"
      :default-country="'pl'"
      :auto-default-country="false"
      :disabled="disabled"
      :value="value"
      :input-options="{ placeholder, type: 'tel', showDialCode: true }"
      class="input-el"
      @input="handleInput"
      @blur="handleBlur"
    >
      <template v-slot:arrow-icon>
        <span class="vti__dropdown-arrow">&nbsp;▼</span>
      </template>
    </vue-tel-input>
    <error-component :errors="errors" />
  </div>
</template>

<script>
import { VueTelInput } from 'vue-tel-input'
import ErrorComponent from '@/components/Error'
import 'vue-tel-input/dist/vue-tel-input.css'

export default {
  components: {
    VueTelInput,
    ErrorComponent
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    errors: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isInvalid() {
      return this.errors
    }
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value)
    },
    handleBlur() {
      this.$emit('blur')
    }
  }
}
</script>

<style lang="scss" scoped>
.field-wrap {
  margin-top: 28px;
}

.input-el {
  border: none !important;

  &:focus-within {
    box-shadow: none;
    border-color: transparent;
  }

  /deep/ input {
    @include input;
  }

  /deep/ .dropdown {
    &:focus {
      outline: none;
    }

    ul {
      top: 100%;

      @include media-down(md) {
        width: calc(100vw - 30px);
      }
    }
  }

  &--invalid {
    /deep/ input {
      border: 2px solid $error;
    }
  }
}

.label {
  @include label;
}

.disabled {
  &,
  /deep/ input,
  /deep/ .dropdown:hover {
    background: #d4d4d4;
  }

  /deep/ .dropdown-arrow {
    display: none;
  }
}

/deep/ .vti__dropdown-list {
  @include media-down(md) {
    position: fixed;
    top: 70px;
    bottom: 0;
    max-height: none;
    z-index: z(phone-input-list);

    .last-preferred {
      border-bottom: 0;
    }
  }
}
</style>
